import { render, staticRenderFns } from "./authPermissionRule.vue?vue&type=template&id=7ccbd628"
import script from "./authPermissionRule.vue?vue&type=script&lang=js"
export * from "./authPermissionRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports